import { useEffect, useState, useCallback } from "react";
import { useOutletContext } from "react-router-dom";

import API_URL from "../../api/API";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";

const WaiverMinorEditor = () => {

    const { business } = useBusinessAuthContext();

    const {
        waiver,refreshChangeSummary,setSaveHandler,setHasUnsavedChanges,
    } = useOutletContext();

    const waiverId = waiver?._id;

    const [minorWaiverAllowed, setMinorWaiverAllowed] = useState(null);

    const [saving, setSaving] = useState(false);

    const [isDirty, setIsDirty] = useState(false);

    
    /*
    ----------------------------------------------------------
    Save Draft
    ----------------------------------------------------------
    */

    const saveDraft = useCallback(async () => { ////////NEW 6th July 2026

        if (saving) return false;

        if (typeof minorWaiverAllowed !== "boolean") {
            return false;
        }

        setSaving(true);

        try {

            const res = await fetch(

                `${API_URL.BUSINESS_WAIVER_SMART_STEP_MINOR_PERMISSION}/${waiverId}`,

                {

                    method: "PATCH",

                    headers: {

                        Authorization: `Bearer ${business.token}`,

                        "Content-Type": "application/json",

                        "x-session-id": business.sessionId,

                        "x-frontend-url": window.location.pathname,

                    },

                    body: JSON.stringify({

                        minorWaiverAllowed,

                    }),

                }

            );

            const data = await res.json();

            if (!data.success) {

                alert(data.message);

                return false;

            }           
            await refreshChangeSummary(); // refreshWaiver() must not be used, because it reloads changes overwritten here.
            
            return true;

        }
        catch (err) {

            console.error(err);

            return false;

        }
        finally {

            setSaving(false);

        }

     }, [
        waiverId,
        minorWaiverAllowed,
        business,
        refreshChangeSummary,
        saving,
    ]); /* Otherwise it will will still recreate saveHandler every render unless saveDraft is stable. */
    

    /* Each tab registers its save function*/  ////////NEW 6th July 2026
    useEffect(() => {
        setSaveHandler(() => saveDraft);
        return () => setSaveHandler(null);
    }, []); /* STOP tracking saveDraft in dependencies - else infintie rendering loop in browser */ 
    
    useEffect(() => {
        setHasUnsavedChanges(isDirty);
    }, [isDirty]); /* setHasUnsavedChanges DO NOT include setter in deps (it’s stable anyway). */
   
    
    
    
    
    /*
    ----------------------------------------------------------
    Load Existing Value
    ----------------------------------------------------------
    */

    useEffect(() => {

        if (!waiver) return;

        setMinorWaiverAllowed(
            waiver.minorWaiverAllowed ?? null
        );

    }, [waiver]);

    /*
    ----------------------------------------------------------
    Update Selection
    ----------------------------------------------------------
    */

    const updateMinorSetting = value => {

        if (value === minorWaiverAllowed) return;

        setMinorWaiverAllowed(value);

        setIsDirty(true);

    };

    /*
    ----------------------------------------------------------
    Auto Save
    ----------------------------------------------------------

    Future Improvement

    This editor may eventually be changed to use an explicit
    "Save Changes" button instead of auto-save, to keep it
    consistent with other settings editors where users make
    deliberate configuration changes.

    For now, auto-save is used to remain consistent with the
    Content Editor.
    */

    useEffect(() => {

        if (!isDirty) return;

        const timer = setTimeout(async () => {

            saveDraft();

            setIsDirty(false);
            setHasUnsavedChanges(false); ////////NEW 6th July 2026

        }, 1500);

        return () => clearTimeout(timer);

    }, [minorWaiverAllowed, isDirty]);

    /*
    ----------------------------------------------------------
    Render
    ----------------------------------------------------------
    */

    return (

        <div className="max-w-3xl">

            <div className="bg-white rounded-xl shadow-sm p-8">

                <h2 className="text-lg font-semibold mb-1">
                    Minors
                </h2>

                <p className="text-sm text-muted-foreground mb-6">
                    Set age rules for signers.
                </p>

                {/* Allow Minors */}

                <button

                    type="button"

                    onClick={() => updateMinorSetting(true)}

                    className={`w-full text-left border rounded-lg p-4 mb-4 transition-colors ${
                        minorWaiverAllowed === true
                            ? "border-yellow-500 bg-yellow-50"
                            : "border-gray-200 hover:border-gray-300"
                    }`}

                >

                    <div className="font-medium">
                        Allow minors
                    </div>

                    <div className="text-sm text-muted-foreground mt-1">
                        Under 18 may sign with guardian consent and co-signature.
                    </div>

                </button>

                {/* Block Minors */}

                <button

                    type="button"

                    onClick={() => updateMinorSetting(false)}

                    className={`w-full text-left border rounded-lg p-4 transition-colors ${
                        minorWaiverAllowed === false
                            ? "border-yellow-500 bg-yellow-50"
                            : "border-gray-200 hover:border-gray-300"
                    }`}

                >

                    <div className="font-medium">
                        Block minors
                    </div>

                    <div className="text-sm text-muted-foreground mt-1">
                        Under 18 signers are automatically blocked.
                    </div>

                </button>

                {saving && (

                    <div className="text-sm text-gray-500 mt-6">

                        Saving...

                    </div>

                )}

                {/*
                ------------------------------------------------------
                Future Improvement

                Replace auto-save with a "Save Changes" button if the
                editor grows or requires confirmation before saving.
                ------------------------------------------------------
                */}

            </div>

        </div>

    );

};

export default WaiverMinorEditor;